export enum Role {
  OWNER = 'OWNER',
  PATIENT_ADMIN = 'PATIENT_ADMIN',
  RX_ADMIN = 'RX_ADMIN',
}
